import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../../services/api";
import { ValuesType as SubmitUrlParams } from "../../../components/SubmitUrlForm";
import { URL_ANALYSIS_STATUS } from "./useUrlAnalysisStatus";
import { prependHttpToUrl } from "../util";

const useSubmitUrl = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({
      url,
      scraper,
      platform,
      geolocation,
      locale,
      rl_dynamic_analysis,
      rlcs_interactive,
      execution_timeout,
      interactive_platform,
      interactive_execution_timeout,
      interactive_geolocation,
      interactive_locale,
      fileless,
      joe
    }: SubmitUrlParams) =>
      api.uriTableFetchAndAnalyze(
        prependHttpToUrl(url),
        scraper,
        platform,
        geolocation,
        locale,
        execution_timeout,
        interactive_platform,
        interactive_execution_timeout,
        interactive_geolocation,
        interactive_locale,
        rl_dynamic_analysis,
        rlcs_interactive,
        fileless,
        joe
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [URL_ANALYSIS_STATUS] });
    }
  });

  return {
    submitUrl: mutation.mutate,
    submitUrlAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    data: mutation.data,
    error: mutation.error
  };
};

export default useSubmitUrl;
